import { Component, Input, Output, EventEmitter } from "@angular/core";
import { Toast } from "@services/toast/toast.service";
import { CommonModule } from "@angular/common";
import { NgIconComponent, provideIcons } from "@ng-icons/core";
import { heroXCircle, heroInformationCircle, heroXMark } from "@ng-icons/heroicons/outline";

@Component({
  selector: "app-toast",
  standalone: true,
  imports: [CommonModule, NgIconComponent],
  templateUrl: "./toast.component.html",
  styleUrls: ["./toast.component.css"],
  providers: [provideIcons({ heroXCircle, heroInformationCircle, heroXMark })],
})
export class ToastComponent {
  @Input() toast!: Toast;
  @Output() remove = new EventEmitter<number>();

  get iconName() {
    switch (this.toast.type) {
      case "error":
        return "heroXCircle";
      case "info":
        return "heroInformationCircle";
      default:
        return "";
    }
  }

  get iconClass() {
    switch (this.toast.type) {
      case "error":
        return "text-red-500";
      case "info":
        return "text-blue-500";
      default:
        return "";
    }
  }

  onRemove() {
    this.remove.emit(this.toast.id);
  }
}
